function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 10.833a3.333 3.333 0 110-6.667 3.333 3.333 0 010 6.667z",
  stroke: "currentColor",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 35.833H5l-.833-9.166-2.5-.834v-7.5A3.333 3.333 0 015 15h5c1.211 0 2.272.648 2.856 1.614",
  stroke: "currentColor",
  strokeWidth: 3,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32.5 10.833a3.334 3.334 0 100-6.667 3.334 3.334 0 000 6.667z",
  stroke: "currentColor",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30 35.833h5l.833-9.166 2.5-.834v-7.5A3.333 3.333 0 0035 15h-5a3.332 3.332 0 00-2.856 1.614",
  stroke: "currentColor",
  strokeWidth: 3,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20 11.667a5 5 0 110-10 5 5 0 010 10zM24.166 38.333h-8.333l-.833-10-3.334-.833v-8.333A3.333 3.333 0 0115 15.833h10a3.333 3.333 0 013.333 3.334V27.5L25 28.333l-.834 10z",
  stroke: "currentColor",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var SvgCouncilMember = function SvgCouncilMember(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    color: "#4038ff"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default "data:image/svg+xml;base64,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";
export { SvgCouncilMember as ReactComponent };